import React, { useContext } from 'react';
import './SearchTodo.css';
import { TodoContext } from '../../TodoContext';

function SearchTodo() {
  const { searchVal, handleSearch } = useContext(TodoContext);
  return (
      <div className='SearchTodo'>
        <input type='text' value={searchVal} onChange={handleSearch} placeholder="Search a To-Do..." />
      </div>
    );
}

export { SearchTodo };